import { view } from "@risingstack/react-easy-state";
import type { NutritionLineType, ProductNutrition } from "../../common/types/productTypes";
import { isProductNutrition } from "../../common/utils/productUtils";
import NutritionLines from "./NutritionLines";

type NutritionWrapperProps = {
   nutrition: NutritionLineType[] | ProductNutrition[];
};

const NutritionWrapper = ({ nutrition }: NutritionWrapperProps) => {
   if (nutrition.length === 0) {
      return null;
   }

   if (isProductNutrition(nutrition)) {
      if (nutrition.length === 1) {
         return <NutritionLines data={nutrition[0].productNutritions} />;
      }

      return nutrition.map((product) => (
         <div className="mb-3" key={product.productName}>
            <h4>{product.productName}</h4>
            <NutritionLines data={product.productNutritions} />
         </div>
      ));
   }

   return <NutritionLines data={nutrition} />;
};

export default view(NutritionWrapper);
